/* eslint-disable no-param-reassign */
import { attachDownloadFileParamToUrl, downloadFileByALink, downloadFileByIframe } from './file';
import fileAxios from '../lib/fileRequest';
import { AxiosResponse } from 'axios';

export interface GUID {
  guid: string;
  fileName: string;
  oldFileId: string;
}

export interface Preview {
  id: string;
  fileId: string;
  definition: string;
  url: string;
  cover: string;
  createTime: number;
  updateTime: number;
  status: number;
  bitrate: number;
  duration: number;
  height: number;
  width: number;
  playId: string;
  provider: string;
}

export interface FileInfo {
  id: string;
  size: number;
  md5: string;
  path: string;
  extension: string;
  fileName: string;
  guid: GUID[];
  state: number;
  provider: string;
  updateTime: number;
  createTime: number;
  previews: Preview[];
  downloadUrl: string;
  urls: { download: string; cdn: string; preview: string };
}

interface SignatureResponse {
  bucket: string;
  currentTimeStamp: null;
  description: string;
  expireTime: null | number;
  expiredTime: 0 | number;
  fileId: string;
  fileName: string;
  guid: string;
  md5: string;
  path: string;
  playId: null;
  provider: 'tencent';
  region: 'ap-chengdu' | string;
  sessionToken: null;
  signature: string;
  subAppId: string;
  tmpSecretId: null;
  tmpSecretKey: null;
  upload: boolean; // 文件是否存在
}

// 根据md5获取签名
export function getSignatureByMd5(md5: string): Promise<AxiosResponse<SignatureResponse>> {
  return fileAxios('/api/files/signatures?version=3.0', {
    method: 'GET',
    params: {
      md5,
      method: 'get',
      provider: 'tencent',
    },
  });
}

// 根据文件id获取文件信息
export function getFileInfoById(id: string): Promise<AxiosResponse<FileInfo>> {
  return fileAxios(`/api/files/${id}?version=3.0`, {
    method: 'GET',
  });
}

// 下载文件，将下载地址的文件名替换为fileName
export const downloadFile = async (
  fileId: string,
  setLoading: Function,
  fileName: string,
  encryptUrl?: string,
  /**
   * 自定义获取文件信息，下载加密视频时使用
   */ customGetFileInfo?: Function,
) => {
  try {
    setLoading && setLoading(true);

    if (fileId) {
      const { data: fileInfo } = customGetFileInfo
        ? await customGetFileInfo(fileId)
        : await getFileInfoById(fileId);

      if (!fileInfo || !fileInfo.path) {
        throw Error('文件信息获取失败，请重试！');
      }
      const { data: sign } = await getSignatureByMd5(fileInfo.md5);

      // 使用 fileInfo 返回的文件拓展名
      const { extension } = fileInfo;
      const name = extension ? `${removeExtension(fileName)}.${extension}` : fileName;

      const downloadUrl = fileInfo.urls?.cdn || fileInfo.path;
      // 加密视频为mp4+ 后缀，下载时需编码
      const encodePath = downloadUrl.replace('.mp4+', `.mp4${encodeURIComponent('+')}`);
      const url = `${encodePath}?${sign.signature}&response-content-type=${encodeURIComponent(
        'application/octet-stream',
      )}&response-content-disposition=${encodeURIComponent('attachment;filename=')}
      ${encodeURIComponent(encodeURIComponent(name))}`;
      const cosDownloadUrl = attachDownloadFileParamToUrl(encryptUrl ||url, name);
      // downloadFileByIframe(cosDownloadUrl);
      downloadFileByALink(cosDownloadUrl, name);

      setLoading && setLoading(false);
    }
  } catch (e: any) {
    setLoading && setLoading(false);
    throw Error(e?.message ?? '下载文件失败，请重试！');
  }
};

function removeExtension(filename: string) {
  if (!filename.includes('.')) {
    return filename;
  }
  return filename.split('.').slice(0, -1).join('.');
}
